import { forwardRef } from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "@/lib/cn";

/**
 * Separator — Radix asosida (a11y: role="separator").
 * Variantlar:
 *   - subtle (default) — border-subtle
 *   - strong — border-strong
 *   - aurora — gradient line (Settings sahifa header'da)
 */
export interface SeparatorProps
  extends React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> {
  variant?: "subtle" | "strong" | "aurora";
}

export const Separator = forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  SeparatorProps
>(({ className, orientation = "horizontal", decorative = true, variant = "subtle", style, ...props }, ref) => (
  <SeparatorPrimitive.Root
    ref={ref}
    decorative={decorative}
    orientation={orientation}
    className={cn(
      "shrink-0",
      orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
      variant === "subtle" && "bg-[var(--border-subtle)]",
      variant === "strong" && "bg-[var(--border-strong)]",
      className,
    )}
    style={
      variant === "aurora"
        ? {
            background:
              "linear-gradient(90deg, transparent 0%, rgba(139,92,246,0.6) 50%, transparent 100%)",
            ...style,
          }
        : style
    }
    {...props}
  />
));
Separator.displayName = "Separator";
